import { JetView, plugins } from 'webix-jet';

/**
 * Class representing the league management view.
 * @extends JetView
 */
export default class leagueManagementView extends JetView {
    /**
     * Configures the layout of the view.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        return {
            type: 'wide',
            cols: [
                {
                    localId: 'inner:layout', // Identifier for the inner layout
                    rows: [
                        {
                            view: 'tabbar', // Tab bar component
                            localId: 'tabbar', // Identifier for the tab bar
                            height: 43, // Height of the tab bar
                            options: [], // Options for the tab bar (empty initially)
                            template:
                                "<span style='font-weight:bold;padding:15px;display:inline-block;'>" +
                                _('Añadir Liga:') + // Localized title for the tab
                                '</span>',
                        },
                        { $subview: true }, // Placeholder for subviews
                    ],
                },
            ],
        };
    }

    /**
     * Initializes the view and sets up event listeners.
     */
    init() {
        this.use(plugins.Menu, this.$$('tabbar')); // Use menu plugin with the tab bar
        this.on(
            this.app,
            'person:select',
            (
                person, // Event listener for person selection
            ) => this.setParam('user', person.id, true), // Set user parameter with selected person's ID
        );
    }
}

// FILE DOCUMENTED
